import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";


const Berlin = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Leading salesforce Consultant and Partner in berlin</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content="Expand your business with Codezix – leading Salesforce consulting and implementation services in Berlin. Smart CRM solutions for growth."
                />
                <meta
                    name="keywords"
                    content="Salesforce consulting berlin Salesforce implementation berlin Codezix Salesforce services CRM solutions berlin Salesforce experts berlin Salesforce partner berlin Custom Salesforce solutions"
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Consultant In Berlin</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/country/berlin.webp')} alt="Salesforce consulting berlin" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <div className="explore-heading text-left">
                                <h2>YSalesforce Consultant in Berlin: Leading Partner and Expert</h2>
                            </div>
                            <p className="prose-lg wow fadeUp">
                                As businesses in Berlin embrace digital transformation, the need for expert Salesforce consultants has never been greater. Salesforce, recognized as one of the world’s most powerful CRM platforms, helps organizations streamline their sales, customer service, and marketing processes. At CodeZix, we are your trusted Salesforce consultant in Berlin, committed to helping you maximize the platform’s capabilities for optimal business growth.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                At Codezix, we offer specialized knowledge and expertise to help businesses implement, customize, and maintain their Salesforce systems. Whether you’re a startup, a mid-sized company, or a large enterprise, we tailor Salesforce solutions to meet your specific needs. From efficient CRM management to advanced marketing automation, our team designs workflows, integrates third-party tools, and provides comprehensive training to ensure your team can fully leverage the system.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                When you partner with a leading Salesforce consultant in Berlin like CodeZix, you gain access to years of experience and expertise. Our consultants are always up-to-date with the latest Salesforce updates and can guide you on the most advanced features and tools available. We work closely with your team to align Salesforce with your business objectives, improving customer relationships, boosting productivity, and driving success.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                In addition to technical expertise, CodeZix provides ongoing support and maintenance to ensure your CRM system continues to operate smoothly. Our role extends far beyond implementation, offering strategic guidance to help your business adapt to evolving market conditions and new business needs.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                Choosing CodeZix as your Salesforce consultant in Berlin will make a lasting difference in your company’s performance. With the right expertise, Salesforce becomes more than just a CRM tool – it becomes a catalyst for enhancing customer engagement, increasing sales, and fostering long-term business growth. Trust CodeZix to be your ideal partner in Salesforce implementation and optimization.
                            </p>

                        </div>
                        <div className='cloud-demo' >
                            <div className="explore-heading text-left">
                                <h2>Salesforce Expert Consulting Services in Berlin for Your Business</h2>
                                <p className="prose-lg wow fadeUp">
                                    Salesforce, one of the leading CRM platforms, offers powerful tools to help organizations manage sales, marketing, and customer service operations efficiently. If you’re looking for a trusted Salesforce consultant in Berlin, CodeZix is here to provide expert consulting services tailored to your unique business needs.
                                </p>
                                <p className="prose-lg wow fadeUp">
                                    As a Salesforce consultant in Berlin, CodeZix specializes in helping businesses of all sizes unlock the full potential of Salesforce. Whether you’re a startup looking to implement your first CRM system or an established enterprise seeking to optimize your existing Salesforce setup, we offer comprehensive services designed to boost productivity and enhance customer engagement.
                                </p>
                                <p className="prose-lg wow fadeUp">
                                    Our team of experts at CodeZix understands that every business is unique, which is why we provide customized solutions to meet your specific requirements. From Salesforce implementation and integration to customization and ongoing support, we ensure that your CRM system is aligned with your business goals. We also offer tailored training for your team, ensuring they can effectively navigate and use Salesforce to drive results.
                                </p>
                                <p className="prose-lg wow fadeUp">
                                    Working with a leading Salesforce consultant in Berlin like CodeZix, means gaining access to the latest Salesforce features and best practices. Our consultants stay up-to-date with the latest updates and trends, ensuring your business is always equipped with the most advanced CRM tools available.
                                </p>
                                <p className="prose-lg wow fadeUp">
                                    Whether you need help with automation, reporting, or creating workflows, CodeZix is your partner in ensuring Salesforce drives long-term success for your business. Let us help you transform your operations and achieve your business objectives with expert Salesforce consulting services in Berlin.
                                </p>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/consulting.webp')} alt='Salesforce implementation berlin' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Consulting</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our certified Salesforce consultants deliver in-depth assessments to understand your business challenges and goals. We develop tailored strategies to optimize workflows, eliminate inefficiencies, and improve cross-departmental alignment. By addressing common CRM pain points—like low sales productivity and miscommunication—our consulting services ensure your Salesforce platform drives measurable performance and supports long-term success.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/implementation.webp')} alt='Codezix Salesforce services ' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Implementation</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Transform your business operations with our expert Salesforce implementation services. Our certified professionals specialize in setting up, configuring, and customizing Salesforce solutions that align perfectly with your business objectives. From initial planning to deployment, we ensure a seamless implementation process that fosters innovation, improves productivity, and supports sustainable growth.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/customization.webp')} alt='CRM solutions berlin ' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Customization</h3>
                                            <p className="wow fadeUp prose-lg">
                                                We create customized Salesforce solutions that reflect your unique business processes and industry requirements. Whether you're addressing CRM inefficiencies or enhancing team collaboration, our Salesforce consultants deliver bespoke configurations that streamline operations and help you get the most value from your platform investment.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/development.webp')} alt='Salesforce experts berlin ' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce App Development</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Bring your ideas to life with our advanced Salesforce app development services. Our certified developers, based in Berlin, design and build scalable, high-performing applications that integrate seamlessly with your Salesforce ecosystem. We tailor every app to your specific business goals, enabling innovation and accelerating digital transformation.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/integration.webp')} alt='Salesforce partner berlin ' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Integration</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Connect your Salesforce platform with essential business systems such as ERP, CMS, DMS, and accounting software through our advanced integration services. We eliminate data silos and improve real-time collaboration by enabling seamless information flow across departments—boosting efficiency, accuracy, and decision-making.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/migration.webp')} alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Migration Services</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Migrate from legacy systems to Salesforce with minimal disruption and maximum data integrity. Our expert team ensures a secure and seamless transition, preserving critical data and enabling your business to fully capitalize on the robust capabilities of the Salesforce platform.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/support.webp')} alt='Salesforce consulting berlin' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Support</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Maintain peak system performance with our comprehensive Salesforce support services. From proactive monitoring and troubleshooting to issue resolution and performance optimization, we ensure your Salesforce environment runs smoothly, reducing downtime and enabling uninterrupted business operations.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='client-section'>
                            <div className='explore-heading text-left'>
                                <h2>Certified Salesforce Consulting Partner in Berlin: Meet Our Expert Team</h2>
                            </div>
                            <p className="prose-lg">As a trusted Salesforce consulting partner in Berlin, our certified team is dedicated to delivering tailored CRM solutions that empower businesses to grow and succeed. With extensive experience in Salesforce implementation, customization, and ongoing support, we help companies across various industries unlock the full potential of the platform. Our approach is personalized, ensuring that every solution aligns with your unique business goals. By choosing a reliable Salesforce consulting partner in Berlin, you gain access to expert insights, streamlined operations, and enhanced customer engagement. Meet the professionals who are ready to elevate your Salesforce experience.</p>
                            <div className='row top'>
                                <Swiper
                                    breakpoints={{
                                        425: {
                                            slidesPerView: 2,
                                            spaceBetween: 10,
                                        },
                                        640: {
                                            slidesPerView: 3,
                                            spaceBetween: 10,
                                        },
                                        768: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 5,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination, Autoplay]}
                                    className="testimonialSwiper-client"
                                >
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/4.webp" alt='Salesforce implementation berlin' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/1.webp" alt='Codezix Salesforce services ' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/2.webp" alt='CRM solutions berlin ' />
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/3.webp" alt='Salesforce experts berlin ' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/5.webp" alt='Salesforce partner berlin ' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/6.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/7.webp" alt='Salesforce consulting berlin' />
                                        </div>
                                    </SwiperSlide>

                                </Swiper>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Our Expertise in Salesforce Clouds: Trusted Salesforce Consultants in Berlin</h2>
                                <p className="wow fadeUp prose-lg text-left">
                                    With deep knowledge across all major Salesforce Clouds, our team of expert Salesforce consultants in Berlin is here to help your business grow through tailored CRM solutions. From Sales Cloud and Service Cloud to Marketing Cloud and Experience Cloud, we specialize in implementing and customizing the right tools to fit your unique needs. Our consultants ensure seamless integration, automation, and user adoption, helping you unlock the full potential of Salesforce. As trusted Salesforce consultants in Berlin, we are committed to driving innovation, improving customer engagement, and delivering measurable results for your business.
                                </p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-berlin#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/einstein-analytics">
                                            <h3 class="mt-0">Einstein Analytics</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-berlin#">
                                            <h3 class="mt-0">Salesforce Lightning</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-berlin#">
                                            <h3 class="mt-0">Health Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-center'>
                                <h2>Industries We Serve with Expert Salesforce Developer Support in Berlin</h2>
                            </div>
                            <p className="prose-lg">
                                Our experienced Salesforce developer team in Berlin provides tailored solutions across a wide range of industries, helping businesses maximize efficiency and customer engagement. From finance and healthcare to retail, manufacturing, and technology, we understand the unique challenges each sector faces. Our developers customize Salesforce to align with specific workflows, compliance requirements, and growth goals. By leveraging automation, custom apps, and seamless integrations, we empower businesses to innovate and scale. As a trusted Salesforce developer in Berlin, we are dedicated to delivering industry-specific CRM solutions that drive real, measurable results for our clients.
                            </p>

                            <div class="row mob-imagebox">
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/healthcare.webp" alt="Salesforce consulting berlin " />
                                        <div class="image-text">
                                            <p>Healthcare</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/retail.webp" alt="Salesforce implementation berlin" />
                                        <div class="image-text">
                                            <p>E-Commerce</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/logistics.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>Logistics</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/financial.webp" alt="CRM solutions berlin " />
                                        <div class="image-text">
                                            <p>Financial</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/manufacturing.webp" alt="Salesforce experts berlin" />
                                        <div class="image-text">
                                            <p>Manufacturing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/publicsector.webp" alt="Salesforce partner berlin" />
                                        <div class="image-text">
                                            <p>Public Sector</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/media.webp" alt="Custom Salesforce solutions" />
                                        <div class="image-text">
                                            <p>Media</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/it.webp" alt="Salesforce consulting berlin" />
                                        <div class="image-text">
                                            <p>IT Industry</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/telecom.webp" alt="Salesforce implementation berlin" />
                                        <div class="image-text">
                                            <p>Telecom</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/education.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>Education</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Why work with Codezix ?</h2>
                            </div>

                            <div className="row bottom">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Certified Salesforce Consulting Partner</li>
                                            <li className="wow fadeUp prose-lg">80+ skilled developers with over 300 certifications</li>
                                            <li className="wow fadeUp prose-lg">89% repeat business rate, showcasing client trust</li>
                                            <li className="wow fadeUp prose-lg">90% client retention rate, building lasting relationships</li>
                                            <li className="wow fadeUp prose-lg">More than 10 years of industry expertise</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Comprehensive End-to-End Support & Maintenance</li>
                                            <li className="wow fadeUp prose-lg">24/7 global Salesforce support, available across all time zones</li>
                                            <li className="wow fadeUp prose-lg">100% in-house development, guaranteeing top-tier quality control</li>
                                            <li className="wow fadeUp prose-lg">99% on-time project delivery, ensuring flawless execution</li>
                                            <li className="wow fadeUp prose-lg">Thorough testing for reliable, high-performance Salesforce solutions</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/pd1.webp" alt='CRM solutions berlin' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">3 PL Central </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in California, <strong>3PL Central</strong> provides a state-of-the-art warehouse management system (WMS) that streamlines operations, enhances customer satisfaction, and drives business growth.
                                            </p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/24-Fit-Club1.webp" alt='Salesforce experts berlin' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">24 Fit Club </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Located in the UK, <strong>24 Fit Club</strong> is a vibrant fitness community committed to enhancing health and well-being. Their expert team offers top-tier fitness coaching, online classes, and innovative insights to inspire clients and encourage body positivity.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/salesforce1.webp" alt='Salesforce partner berlin' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Active Campaign </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Salesforce is a robust CRM platform that provides a comprehensive enterprise solution, accessible across multiple devices. Its dynamic app marketplace strengthens marketing and sales collaboration, boosting lead generation and cultivating high-quality pipelines.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/advologix.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Advologix</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Headquartered in Sugarland, Texas, Advologix is a digital consultancy specializing in legal document and case management. They help law firms, legal departments, and public service organizations streamline case processing through centralized information management systems.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/concert_health.webp" alt='Salesforce consulting berlin' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Concert Health</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Concert Health supports physician practices in integrating behavioral health services, such as care management, brief therapy, and psychiatric consultations. With a team of expert clinicians, valuable industry insights, and cutting-edge technology, they enhance patient care and drive better outcomes.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/at-home-solutions.webp" alt='Salesforce implementation berlin' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">At Home Solutions</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in Berlin, At Home Solutions provides personalized healthcare services designed to enhance the quality of life for individuals of all ages. With over a decade of experience, they offer affordable, effective care, including companionship, customized support, and essential medical services.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/commerce.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Commerce Cloud: Everything You Need to Know</h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today's digital landscape, e-commerce is crucial for business success and fuels intense competition. As online shopping demand continues to rise, businesses must implement scalable, innovative solutions to stay ahead of the curve and meet ever-changing consumer expectations.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/agent.webp" alt='CRM solutions berlin' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Ultimate Guide to Salesforce Agentforce</h3>
                                            <p className="wow fadeUp prose-lg">
                                                A key highlight of 2025 is Salesforce Agentforce. On Day Three of Dreamforce 2024, Salesforce unveiled Agentforce, a groundbreaking AI-powered tool designed to enhance employee productivity.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/marketing.webp" alt='Salesforce experts berlin' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                Understanding Salesforce MuleSoft & How Codezix Supports Implementation & Customization
                                            </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today’s digital landscape, businesses utilize various applications and platforms to streamline operations and enhance customer experiences. However, achieving seamless integration can be a challenge—this is where Salesforce MuleSoft becomes essential.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Berlin;